import { registerFeature } from "lib/features"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Typography } from "@mui/material"
import { ScheduleCodeDisplay } from "slot-definitions"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_PREFER_UNIQUE_CODES } from "plugins/UniqueCodes/server/feature-flag.mjs"

registerFeature({
    numericalId: 1001,
    name: "Prefer Unique Codes",
    id: FEATURE_FLAG_PREFER_UNIQUE_CODES,
    description: `Enables the display of unique codes for a client, rather than complete schedule codes`,
    readyForBeta: false,
    readyForProduction: false,
    internalUseOnly: true,
})

ScheduleCodeDisplay.plug(replaceAllWith(<UniqueCode predicate={() => isEnabled(FEATURE_FLAG_PREFER_UNIQUE_CODES)} />))

function UniqueCode({ sx, code, modified }) {
    code ??= modified?.code
    if (!code) return null
    if (code.startsWith("C")) {
        let extra = code.split("-").slice(4).join("-")
        if (extra.length > 1) {
            code = extra
        } else {
            extra = code.split("-").slice(2).join("-")
            if (extra.length > 1) {
                code = extra
            }
        }
    }
    return (
        <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary", ml: 2, whiteSpace: "nowrap", ...sx }}
        >
            #{code}
        </Typography>
    )
}
